import { Button, Callout, Flex } from "@radix-ui/themes";
import { useMutation } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthRoot } from "../auth-root.component";
import { authClient } from "../client/auth-client";
import { getErrorMessage } from "../client/auth-client-errors";

export function VerificationSentPage() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email") ?? "";
  const resendVerificationMutation = useMutation({
    mutationFn: async (input: { email: string }) => {
      await authClient.sendVerificationEmail(input);
    },
    onSuccess: () => {
      toast.success("Bestätigungs-E-Mail wurde erneut gesendet.");
    },
    onError: (error) => {
      toast.error(getErrorMessage(error));
    },
  });

  return (
    <AuthRoot title="E-Mail bestätigen">
      <Callout.Root color="blue">
        <Callout.Text>
          Wir haben Ihnen eine Bestätigungs-E-Mail gesendet. Öffnen Sie den Link
          in der E-Mail, um Ihr Konto zu aktivieren.
        </Callout.Text>
      </Callout.Root>
      {email && (
        <Flex direction="column" gap="2" align="start">
          <Button
            type="button"
            variant="ghost"
            disabled={resendVerificationMutation.isPending}
            loading={resendVerificationMutation.isPending}
            onClick={() => {
              resendVerificationMutation.mutate({ email });
            }}
          >
            Bestätigungs-E-Mail erneut senden
          </Button>
        </Flex>
      )}
    </AuthRoot>
  );
}
